/**
 * Модуль для работы с записями табельного учета
 * @module workrecords
 */

import { cleanParams } from "@/utils";

/**
 * Получение списка записей табельного учета
 * @param {Object} params - параметры запроса
 * @returns {Promise} - данные записей
 * @throws {Error} - ошибка при получении данных
 */
export const getList = async (params) => {
  const cleanedFilters = cleanParams(params);
  const queryString = new URLSearchParams(cleanedFilters).toString();

  try {
    const response = await fetch(`/api/workrecords/employees?${queryString}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = await response.json();

    if (!response.ok || data.error) {
      throw new Error(
        `Ошибка при получении данных. ${data.error || "Обновите страницу"}`
      );
    }

    return data;
  } catch (err) {
    throw err;
  }
};

/**
 * Создание новой записи табельного учета
 * @param {Object} item - данные записи
 * @returns {Promise} - созданная запись
 * @throws {Error} - ошибка при создании данных
 */
export const createRecord = async (item) => {
  try {
    const response = await fetch("/api/workrecord", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(item),
    });

    const data = await response.json();

    if (!response.ok || data.error) {
      throw new Error(
        `Ошибка при создании данных. ${data.error || "Попробуйте снова"}`
      );
    }

    return data.record;
  } catch (err) {
    throw err;
  }
};

/**
 * Обновление существующей записи табельного учета
 * @param {Object} item - данные записи
 * @returns {Promise} - обновленная запись
 * @throws {Error} - ошибка при обновлении данных
 */
export const updateRecord = async (item) => {
  try {
    const response = await fetch("/api/workrecord", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(item),
    });

    const data = await response.json();

    if (!response.ok || data.error) {
      throw new Error(
        `Ошибка при обновлении данных. ${data.error || "Попробуйте снова"}`
      );
    }

    return data.record;
  } catch (err) {
    throw err;
  }
};
